var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-wrap module-atlas",attrs:{"mapData":_vm.mapData}},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.moduleTitle)}}),_c('div',{staticClass:"map-wrap"})])
}
var staticRenderFns = []

export { render, staticRenderFns }